import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import { createApp, h } from "vue";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "v-calendar/style.css";
import { Calendar, DatePicker, setupCalendar } from "v-calendar";

InertiaProgress.init();

createInertiaApp({
  resolve: (name) => require(`./Pages/${name}`),
  title: (title) => title ?? "CDS",
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(setupCalendar, {})
      .use(Toast)
      .component("VCalendar", Calendar)
      .component("VDatePicker", DatePicker)
      .mount(el);
  },
});
